import React from "react";

const EmptyView: React.FC = () => <React.Fragment />;

export default EmptyView;
